import { useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { isEmail } from "validator";
import { register } from "../../../../services/auth.service";
import Button from "../../../../components/button";
import styles from "./styles.module.css";

const RegisterUser = ({ handleClose }) => {
  const [username, setUsername] = useState("");
  const [emailT, setEmailT] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [successful, setSuccessful] = useState(false);

  const required = (value) => {
    if (!value) {
      return (
        <div className={styles.validationError} role="alert">
          ¡Este campo es obligatorio!
        </div>
      );
    }
  };

  const email = (value) => {
    if (!isEmail(value)) {
      return (
        <div className={styles.validationError} role="alert">
          Esto no es un correo electrónico válido.
        </div>
      );
    }
  };

  const vusername = (value) => {
    if (value.length < 3 || value.length > 20) {
      return (
        <div className={styles.validationError} role="alert">
          El nombre de usuario debe tener entre 3 y 20 caracteres.
        </div>
      );
    }
  };

  const vpassword = (value) => {
    if (value.length < 6 || value.length > 40) {
      return (
        <div className={styles.validationError} role="alert">
          La contraseña debe tener entre 6 y 40 caracteres.
        </div>
      );
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    setMessage("");
    setSuccessful(false);

    let email_valid = email(emailT);
    let user_valid = vusername(username);
    let pass_valid = vpassword(password);

    if (!email_valid && !user_valid && !pass_valid) {
      register(username, emailT, password).then(
        (response) => {
          setMessage(response.data.message);
          setSuccessful(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setSuccessful(false);
          setMessage(resMessage);
        }
      );
    }
  };

  const handleCancel = () => {
    setUsername("");
    setEmailT("");
    setPassword("");
    setMessage("");
    setSuccessful(false);
    handleClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalCard}>
        <div className={styles.modalTitle}>
          <h3>Registrar Usuario</h3>
        </div>
        <Form onSubmit={handleRegister}>
          {!successful && (
            <div>
              <div className={styles.formGroup}>
                <label htmlFor="username" className={styles.formLabel}>
                  Nombre de usuario*
                </label>
                <Input
                  type="text"
                  name="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  validations={[required, vusername]}
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.formLabel}>
                  Email
                </label>
                <Input
                  type="text"
                  name="email"
                  value={emailT}
                  onChange={(e) => setEmailT(e.target.value)}
                  validations={[required, email]}
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="password" className={styles.formLabel}>
                  Contraseña*
                </label>
                <Input
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  validations={[required, vpassword]}
                />
              </div>
              <div className={styles.buttonGroup}>
                <Button variant="primary" onClick={handleRegister}>
                  Registrar
                </Button>
                <Button variant="secondary" onClick={handleCancel}>
                  Cancelar
                </Button>
              </div>
            </div>
          )}

          {message && (
            <div className={styles.formGroup}>
              <div
                className={
                  successful ? styles.alertSuccess : styles.alertDanger
                }
                role="alert"
              >
                {message}
              </div>
              <Button variant="secondary" onClick={handleCancel}>
                Cerrar
              </Button>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default RegisterUser;
